import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { LocalStorageActions } from "../../Redux-Reducer/LocalStorageReducer";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import TranslationService from "../../Services/Translation/TranslationService";
/** Styles Import */
import "./Style.css";
/** Components Import */
import { Form, Button, Alert } from "react-bootstrap";
import Business from "./Business";
import Worker from "./Worker";
import Loading from "../../Components/Loading";
import swal from "../../Components/SweetAlert2";
import Dialog from "../../Components/Dialog";
import AutoTranslate from "../../Components/AutoTranslate";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const authorization = useSelector(
    (state) => state.localStorage.authorization,
  );
  const [userId, setUserId] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [warningShow, setWarningShow] = useState(false);
  const [findDialog, setFindDialog] = useState({
    show: false,
    type: 0,
    title: "계정 찾기",
    userName: "",
    userId: "",
    userEmail: "",
  }); // 계정 찾기 토글
  const [qrCode, setQrCode] = useState("");
  const [startTimer, setStartTimer] = useState(false);
  const [timer, setTimer] = useState(180);
  const timerRef = useRef(null);
  const searchRef = useRef(null);
  const language = useSelector((state) => state.localStorage.language);
  const [wording, setWording] = useState({
    loginFindDialogIdPlaceholder: "ID",
    loginFindDialogNamePlaceholder: "이름",
    loginFindDialogEmailPlaceholder: "이메일",
  });
  const [secretClicks, setSecretClicks] = useState({
    leftTop: false,
    leftBottom: false,
    rightTop: false,
    rightBottom: false,
  });
  const [secretDialog, setSecretDialog] = useState(false);
  const [secretDialogText, setSecretDialogText] = useState("");

  const loginType = location.state?.type || "worker";

  useEffect(() => {
    console.log("location: ", location);
    Init();
  }, [loginType]);

  // authorization 상태 변화 감지 (초기 로드 시에만)
  useEffect(() => {
    if (authorization.auth && location.pathname === "/login") {
      navigate("/");
    }
  }, [authorization.auth, navigate, location.pathname]);

  useEffect(() => {
    if (startTimer) {
      // 타이머 카운트다운
      timerRef.current = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(timerRef.current);
            clearInterval(searchRef.current); // Search1 호출도 중단
            setStartTimer(false);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);

      // 3초마다 Search1 호출
      searchRef.current = setInterval(() => {
        Search1();
      }, 3000);

      // // 테스트를 위한 근로자 자동 로그인
      // // 3초마다 Search1 호출
      // searchRef.current = setInterval(() => {
      //   Search2();
      // }, 3000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      if (searchRef.current) {
        clearInterval(searchRef.current);
      }
    };
  }, [startTimer]);

  useEffect(() => {
    const allTrue = Object.values(secretClicks).every(
      (value) => value === true,
    );

    if (allTrue) {
      setSecretDialog(true);
      setSecretClicks({
        leftTop: false,
        leftBottom: false,
        rightTop: false,
        rightBottom: false,
      });
    }
  }, [secretClicks]);

  const Init = async () => {
    try {
      if (Commons.Storages("get", "popup").loginEduPopup) {
        Commons.Storages("set", "popup", {
          ...Commons.Storages("get", "popup"),
          loginEduPopup: false,
        });
      }
      if (loginType === "worker") {
        // 로그인 타입 전환 시 타이머/세션 초기화 후 QR 재생성
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
        if (searchRef.current) {
          clearInterval(searchRef.current);
        }
        setStartTimer(false);
        setTimer(180);
        setQrCode("");
        await Search();
      } else if (loginType === "business") {
        // 관리자 화면 전환 시 QR 관련 상태 초기화
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
        if (searchRef.current) {
          clearInterval(searchRef.current);
        }
        setStartTimer(false);
        setQrCode("");
        const _loginFindDialogIdPlaceholder =
          await TranslationService.translateText("ID", language.lang);
        const _loginFindDialogNamePlaceholder =
          await TranslationService.translateText("이름", language.lang);
        const _loginFindDialogEmailPlaceholder =
          await TranslationService.translateText("이메일", language.lang);
        setWording({
          loginFindDialogIdPlaceholder: _loginFindDialogIdPlaceholder,
          loginFindDialogNamePlaceholder: _loginFindDialogNamePlaceholder,
          loginFindDialogEmailPlaceholder: _loginFindDialogEmailPlaceholder,
        });
      }
    } catch (e) {
      console.log("Init 로직 오류: ", e);
    }
  };

  // QR 생성 로직
  const Search = async () => {
    try {
      // 기존 타이머와 검색 중단
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      if (searchRef.current) {
        clearInterval(searchRef.current);
      }
      setStartTimer(false);

      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.Account.startLoginSession,
      ).then((result) => {
        let data = result.data;
        console.log("QR 생성 결과: ", data);
        if (!data) {
          throw new Error("QR 생성 실패");
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          setQrCode(data.loginSessionId);
          setStartTimer(true);
        }
      });
    } catch (e) {
      console.log("Search error: ", e);
    } finally {
    }
  };

  // 근로자 로그인 로직
  const Search1 = async () => {
    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Account.checkSession,
        { loginSessionId: qrCode },
      ).then(async (result) => {
        let data = result.data;
        console.log("Search1: ", data);
        if (!data) {
          throw new Error("QR 생성 실패");
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          if (data.status === "AUTHORIZED") {
            setTimer(0);
            setStartTimer(false);
            await Sumit1(data.token, data.notice);
          } else if (data.status === "PENDING") {
          } else {
            setTimer(0);
            setStartTimer(false);
          }
        }
      });
    } catch (e) {
      console.log("Search1 error: ", e);
    } finally {
    }
  };

  // 임시 보여주기 용 로직
  const Search2 = async () => {
    try {
      const response = await Commons.Axios(
        "post",
        Global.base.useUrl + "api/AccountEmployee/GetTokenEmployeeRequest",
        {},
        {
          empId: 200,
          deviceKey: "d02adba7-5cfa-45ef-b51f-734b990eff6b",
          fcmToken: "WEB",
        },
      );
      console.log("Search2 response: ", response.data);
      await Sumit1(response.data.userInfo.token, response.data.notice);
    } catch (e) {
      console.log("Search1 error: ", e);
    } finally {
    }
  };

  // 로그인 로직
  const Sumit = async () => {
    try {
      setLoading(true);
      await IndexedDb.ClearTable("UserInfo");

      if (loginType === "business") {
        await Commons.Axios(
          "post",
          Global.base.useUrl + Global.urls.Account.login,
          {},
          {
            userId: userId,
            password: userPassword,
            fcmToken: "WEB",
          },
        ).then((result) => {
          let data = result.data;
          console.log("로그인 결과: ", data);

          if (!data) {
            throw new Error("ID 또는 비밀번호가 \n 일치하지 않습니다.");
          } else if (data.type === "Error") {
            throw new Error("ID 또는 비밀번호가 일치하지 않습니다.");
          } else {
            IndexedDb.AddItem("UserInfo", [
              {
                token: data.userInfo.token,
                userId: data.userInfo.userId,
                userNm: data.userInfo.userNm,
                eMail: data.userInfo.eMail,
                postNo: data.userInfo.postNo,
                address1: data.userInfo.address1,
                address2: data.userInfo.address2,
                tel: data.userInfo.tel,
                validaty: data.userInfo.validaty,
                refreshToken: data.userInfo.refreshToken,
                id: data.userInfo.id,
                guidId: data.userInfo.guidId,
                expiredTime: data.userInfo.expiredTime,
                connTime: Commons.DateFormating(new Date(), 1),
                plantList: data.plantList,
                auth: data.auth,
                companyCode: data.userInfo.companyCode,
                companyName: data.userInfo.companyName,
                industryCode: data.userInfo.industryCode,
                industryName: data.userInfo.industryName,
                photoUrl: data.userInfo.photoUrl,
                concent: data.userInfo.concent === true,
              },
            ]);
            dispatch(
              LocalStorageActions.setAuthorization({
                auth: true,
                authDate: Commons.DateFormating(new Date()),
                authType: "b",
              }),
            );
            Commons.Storages("set", "userInfo", {
              userId: data.userInfo.userId,
              userName: data.userInfo.userNm,
            });
            // 로그인 성공 후 직접 네비게이션
            console.log("사업주 로그인 성공, 메인 페이지로 이동");
            setTimeout(() => {
              navigate("/");
            }, 100);
          }
        });
      } else {
        await Commons.Axios(
          "post",
          Global.base.useUrl + Global.urls.Account.loginEmployee,
          {},
          {
            empId: 168,
            deviceKey: "7e4fa2ea-6d31-4c50-b2c4-5c88c0426014",
            fcmToken: "WEB",
          },
        ).then((result) => {
          let data = result.data;
          console.log("로그인 결과: ", data);

          if (!data) {
            throw new Error(data);
          } else if (data.type === "Error") {
            throw new Error(data.message);
          } else {
            IndexedDb.AddItem("UserInfo", [
              {
                token: data.userInfo.token,
                userId: data.userInfo.userId,
                userNm: data.userInfo.userNm,
                eMail: data.userInfo.eMail,
                photoUrl: data.userInfo.photoUrl,
                concent: data.userInfo.concent === true,
                address1: data.userInfo.address1,
                address2: data.userInfo.address2,
                validaty: data.userInfo.validaty,
                refreshToken: data.userInfo.refreshToken,
                id: data.userInfo.id,
                guidId: data.userInfo.guidId,
                expiredTime: data.userInfo.expiredTime,
                connTime: Commons.DateFormating(new Date(), 1),
                auth: data.auth,
              },
            ]);
            dispatch(
              LocalStorageActions.setAuthorization({
                auth: true,
                authDate: Commons.DateFormating(new Date()),
                authType: "e",
              }),
            );
            Commons.Storages("set", "userInfo", {
              userId: data.userInfo.userId,
              userName: data.userInfo.userNm,
            });
            // 로그인 성공 후 직접 네비게이션
            console.log("근로자 로그인 성공, 메인 페이지로 이동");
            setTimeout(() => {
              navigate("/");
            }, 100);
          }
        });
      }
    } catch (e) {
      console.log("ID 중복 확인 로직 오류: ", e);
      if (e.message) {
        swal.error(e.message);
      } else {
        swal.error("로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요.");
      }
    } finally {
      setLoading(false);
    }
  };

  // QR로 로그인(근로자 로그인)
  const Sumit1 = async (_param = "", _param1 = {}) => {
    try {
      await IndexedDb.ClearTable("UserInfo");
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Account.refreshToken,
        {
          token: _param,
          fcmToken: "WEB",
        },
      ).then(async (result) => {
        let data = result.data;
        console.log("Sumit1: ", data);
        const response = await Commons.Axios(
          "get",
          Global.base.useUrl + Global.urls.Common.notAuthGetCode,
          { code: "NATIONALITY" },
        );
        console.log("response nationality: ", response.data);

        if (!data) {
          throw new Error("RefreshToken 실패");
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          if (response.status === 200) {
            if (Array.isArray(response.data)) {
              response.data.forEach((item) => {
                if (item.code === data.userInfo.nationality) {
                  dispatch(LocalStorageActions.setLanguage(item));
                  Commons.Storages("set", "language", item);
                }
              });
            }
          }
          IndexedDb.AddItem("UserInfo", [
            {
              token: data.userInfo.token,
              userId: data.userInfo.userId,
              userNm: data.userInfo.userNm,
              eMail: data.userInfo.eMail,
              photoUrl: data.userInfo.photoUrl,
              birth: data.userInfo.birth,
              bloodType: data.userInfo.bloodType,
              privacyAgreement: data.userInfo.concent === true,
              concent: data.userInfo.concent === true,
              profileImage: data.userInfo.photoUrl,
              gender: data.userInfo.gender,
              tel: data.userInfo.tel,
              points: data.userInfo.points,
              address1: data.userInfo.address1,
              address2: data.userInfo.address2,
              validaty: data.userInfo.validaty,
              refreshToken: data.userInfo.refreshToken,
              nationality: data.userInfo.nationality,
              language: data.userInfo.language,
              id: data.userInfo.id,
              guidId: data.userInfo.guidId,
              expiredTime: data.userInfo.expiredTime,
              connTime: Commons.DateFormating(new Date(), 1),
              auth: data.auth,
            },
          ]);
          dispatch(
            LocalStorageActions.setAuthorization({
              auth: true,
              authDate: Commons.DateFormating(new Date()),
              authType: "e",
            }),
          );
          Commons.Storages("set", "userInfo", {
            userId: data.userInfo.userId,
            userName: data.userInfo.userNm,
          });
          // QR 로그인의 경우 state를 전달하기 위해 직접 네비게이션
          if (_param1) {
            setTimeout(() => {
              navigate("/", { state: { notice: _param1 } });
            }, 100);
          }
        }
      });
    } catch (e) {
      console.log("ID 중복 확인 로직 오류: ", e);
      swal.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  const HandleSubmit = async (e) => {
    e.preventDefault();
    if (loginType === "business") {
      if (!userId || !userPassword) {
        setWarningShow(true);
      } else {
        await Sumit();
      }
    } else {
      await Sumit();
    }
  };

  return (
    <div className="sign-in__wrapper">
      <div
        className="sign-in-secret-container sign-in-secret-left-top"
        onClick={() =>
          setSecretClicks({ ...secretClicks, leftTop: !secretClicks.leftTop })
        }
      />
      {/* <div className='sign-in-secret-container sign-in-secret-left-bottom' onClick={() => setSecretClicks({ ...secretClicks, leftBottom: !secretClicks.leftBottom })} /> */}
      <div
        className="sign-in-secret-container sign-in-secret-left-bottom"
        onClick={() =>
          setSecretClicks({
            leftTop: true,
            leftBottom: true,
            rightTop: true,
            rightBottom: true,
          })
        }
      />
      <div
        className="sign-in-secret-container sign-in-secret-right-top"
        onClick={() =>
          setSecretClicks({ ...secretClicks, rightTop: !secretClicks.rightTop })
        }
      />
      <div
        className="sign-in-secret-container sign-in-secret-right-bottom"
        onClick={() =>
          setSecretClicks({
            ...secretClicks,
            rightBottom: !secretClicks.rightBottom,
          })
        }
      />
      <div className="sign-in__backdrop" />
      {loginType === "business" ? (
        <Form className="shadow p-4 bg-white rounded" onSubmit={HandleSubmit}>
          <div className="h4 mb-3 text-center">
            <AutoTranslate targetLanguage={language.lang}>로그인</AutoTranslate>
          </div>
          {warningShow ? (
            <Alert
              className="mb-2"
              variant="danger"
              onClose={() => setWarningShow(false)}
              dismissible
            >
              <AutoTranslate targetLanguage={language.lang}>
                아이디 또는 비밀번호가 일치하지 않습니다.
              </AutoTranslate>
            </Alert>
          ) : null}
          <Business
            userId={userId}
            setUserId={setUserId}
            userPassword={userPassword}
            setUserPassword={setUserPassword}
          />
          <Button className="w-100" variant="primary" type="submit">
            <AutoTranslate targetLanguage={language.lang}>로그인</AutoTranslate>
          </Button>
          <div className={`flex-between mt-2`}>
            <Button
              className="text-muted px-0"
              variant="link"
              onClick={() =>
                navigate("/signup", { state: { type: loginType } })
              }
            >
              <AutoTranslate targetLanguage={language.lang}>
                회원가입
              </AutoTranslate>
            </Button>
            <Button
              className="text-muted px-0"
              variant="link"
              onClick={async () => {
                const _title = await TranslationService.translateText(
                  "계정 찾기",
                  language.lang,
                );
                setFindDialog({ ...findDialog, show: true, title: _title });
              }}
            >
              <AutoTranslate targetLanguage={language.lang}>
                계정 찾기
              </AutoTranslate>
            </Button>
          </div>
          {/* 근로자 로그인으로 전환 링크 */}
          <div className="business-login-switch">
            <Button
              variant="link"
              className="btn-link"
              onClick={() => {
                navigate("/login", {
                  state: { type: "worker" },
                  replace: true,
                });
              }}
            >
              <AutoTranslate targetLanguage={language.lang}>
                근로자 로그인하기
              </AutoTranslate>
            </Button>
          </div>
        </Form>
      ) : (
        <Worker
          qrCode={qrCode}
          onRefresh={() => {
            // 기존 타이머와 검색 중단
            if (timerRef.current) {
              clearInterval(timerRef.current);
            }
            if (searchRef.current) {
              clearInterval(searchRef.current);
            }
            setStartTimer(false);
            setTimer(180);
            Search();
          }}
          timer={timer}
          startTimer={startTimer}
          onSwitchToBusiness={() => {
            navigate("/login", {
              state: { type: "business" },
              replace: true,
            });
          }}
        />
      )}
      {loading && <Loading />}
      <Dialog
        show={findDialog.show}
        onHide={() =>
          setFindDialog({
            ...findDialog,
            show: false,
            type: 0,
            title: "계정 찾기",
            userName: "",
            userId: "",
            userEmail: "",
          })
        }
        title={findDialog.title}
        footer={findDialog.type === 0 ? false : true}
        footerChildren={
          findDialog.type === 1 ? (
            <Button variant="primary" onClick={() => {}}>
              <AutoTranslate targetLanguage={language.lang}>
                ID 찾기
              </AutoTranslate>
            </Button>
          ) : (
            <Button variant="primary" onClick={() => {}}>
              <AutoTranslate targetLanguage={language.lang}>
                비밀번호 찾기
              </AutoTranslate>
            </Button>
          )
        }
      >
        <Form>
          {findDialog.type === 0 ? (
            <Form.Group className="d-flex justify-content-between gap-5 py-3">
              <Button
                className="w-100"
                style={{ height: "150px", fontSize: "1.5rem" }}
                variant="outline-primary"
                onClick={async () => {
                  const _title = await TranslationService.translateText(
                    "ID 찾기",
                    language.lang,
                  );
                  setFindDialog({ ...findDialog, type: 1, title: _title });
                }}
              >
                <AutoTranslate targetLanguage={language.lang}>
                  ID 찾기
                </AutoTranslate>
              </Button>
              <Button
                className="w-100"
                style={{ height: "150px", fontSize: "1.5rem" }}
                variant="outline-primary"
                onClick={async () => {
                  const _title = await TranslationService.translateText(
                    "비밀번호 찾기",
                    language.lang,
                  );
                  setFindDialog({ ...findDialog, type: 2, title: _title });
                }}
              >
                <AutoTranslate targetLanguage={language.lang}>
                  비밀번호 찾기
                </AutoTranslate>
              </Button>
            </Form.Group>
          ) : findDialog.type === 1 ? (
            <Form.Group className="d-flex flex-column gap-3 py-3">
              <Form.Control
                type="text"
                placeholder={wording.loginFindDialogNamePlaceholder}
                value={findDialog.userName}
                onChange={(e) =>
                  setFindDialog({ ...findDialog, userName: e.target.value })
                }
              />
              <Form.Control
                type="text"
                placeholder={wording.loginFindDialogEmailPlaceholder}
                value={findDialog.userEmail}
                onChange={(e) =>
                  setFindDialog({ ...findDialog, userEmail: e.target.value })
                }
              />
            </Form.Group>
          ) : (
            <Form.Group className="d-flex flex-column gap-3 py-3">
              <Form.Control
                type="text"
                placeholder={wording.loginFindDialogNamePlaceholder}
                value={findDialog.userName}
                onChange={(e) =>
                  setFindDialog({ ...findDialog, userName: e.target.value })
                }
              />
              <Form.Control
                type="text"
                placeholder={wording.loginFindDialogIdPlaceholder}
                value={findDialog.userId}
                onChange={(e) =>
                  setFindDialog({ ...findDialog, userId: e.target.value })
                }
              />
              <Form.Control
                type="text"
                placeholder={wording.loginFindDialogEmailPlaceholder}
                value={findDialog.userEmail}
                onChange={(e) =>
                  setFindDialog({ ...findDialog, userEmail: e.target.value })
                }
              />
            </Form.Group>
          )}
        </Form>
      </Dialog>
      {/* <Dialog show={showDialog} onHide={() => setShowDialog(false)} title='비밀번호 찾기' footer footerChildren={<Button onClick={() => {}}>비밀번호 변경</Button>}>
        <Form>
          <Form.Group className='my-3'>
            <Form.Label>현재 비밀번호</Form.Label>
            <Form.Control type='password' />
          </Form.Group>
          <Form.Group className='my-3'>
            <Form.Label>새 비밀번호</Form.Label>
            <Form.Control type='password' />
          </Form.Group>
          <Form.Group className='my-3'>
            <Form.Label>새 비밀번호 확인</Form.Label>
            <Form.Control type='password' />
          </Form.Group>
        </Form>
      </Dialog> */}
      <Dialog
        show={secretDialog}
        onHide={() => setSecretDialog(false)}
        title="*****"
        footer
        footerChildren={
          <Button
            type="submit"
            onClick={() => {
              if (secretDialogText === "vari@#1101") {
                navigate("/signup", {
                  state: { type: loginType, secret: true },
                });
              } else {
                setSecretDialogText("");
                setSecretDialog(false);
              }
            }}
          >
            확인
          </Button>
        }
      >
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            if (secretDialogText === "vari@#1101") {
              navigate("/signup", { state: { type: loginType, secret: true } });
            } else {
              setSecretDialogText("");
              setSecretDialog(false);
            }
          }}
        >
          <Form.Group className="d-flex flex-column gap-3 py-3">
            <Form.Control
              type="password"
              value={secretDialogText}
              onChange={(e) => setSecretDialogText(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Dialog>
    </div>
  );
}

export default Login;
